import { styled } from '@mui/material';

type ComponentProps = {
  isDarkMode: boolean;
};

export const FooterWrapper = styled(
  'div',
  {shouldForwardProp: (prop) => prop !== 'isDarkMode'},
)<ComponentProps>`
    background-color: ${({isDarkMode}) => (isDarkMode ? '#000' : '#F3F3F3')};
    display: flex;
    justify-content: space-between;
    padding-top: 1rem;
    padding-bottom: 1rem;
    margin-top: 1px;
    font-size: 10px;
`;

export const FooterText = styled(
  'span',
  {shouldForwardProp: (prop) => prop !== 'isDarkMode'},
)<ComponentProps>`
  color: ${ ({ isDarkMode }) => (isDarkMode ? '#fff' : '#000') };
`;

export const FooterLink = styled(
  'a',
  {shouldForwardProp: (prop) => prop !== 'isDarkMode'},
)<ComponentProps>`
    color: ${({isDarkMode}) => (isDarkMode ? '#fff' : '#000')};
`;

export const FooterBuildContainer = styled('div')`
    padding-left: 1rem;
`

export const FooterCopyrightContainer = styled('div')`
    padding-right: 90px;
`;

export const TrialBannerWrapper = styled('div')`
    width: 100%;
    background-color: #c7e0f4;
    padding: 0.5rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    text-align: center;
`;

export const TrialBannerText = styled('span')`
    color: black;
`;

export const AppFooter = styled('div')`
    position: fixed;
    bottom: 0;
    width: 100%;
`;